var exports = {
  "i": "x0a7806d5--9bb582--wrapper",
};

module.exports = exports;
